/**
 * Devises supportées et helpers de formatage des prix.
 *
 * Devise par défaut : le Franc CFA (FCFA / code ISO XOF). Placée en tête de
 * liste pour être proposée et pré-sélectionnée par défaut dans les formulaires.
 */
export const DEFAULT_CURRENCY = 'XOF';

export const CURRENCIES = [
  { code: 'XOF', symbol: 'FCFA', name: 'Franc CFA' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'USD', symbol: '$', name: 'Dollar' },
  { code: 'GBP', symbol: '£', name: 'Livre' },
  { code: 'CHF', symbol: 'CHF', name: 'Franc suisse' },
];

/** Symbole d'affichage d'une devise (retombe sur la devise par défaut si inconnue). */
export const currencySymbol = (code) => {
  const match =
    CURRENCIES.find((c) => c.code === code) ||
    CURRENCIES.find((c) => c.code === DEFAULT_CURRENCY);
  return match.symbol;
};

/**
 * Formate un montant avec sa devise : « 12 500 FCFA », « 99 € ».
 * Le FCFA s'écrit sans décimales (centimes inexistants) ; les autres devises
 * en conservent jusqu'à 2 si nécessaire. Le symbole est placé après le montant
 * (convention francophone et FCFA).
 */
export const formatPrice = (amount, code = DEFAULT_CURRENCY) => {
  const value = Number(amount) || 0;
  const maximumFractionDigits = code === 'XOF' ? 0 : 2;
  const formatted = new Intl.NumberFormat('fr-FR', { maximumFractionDigits }).format(value);
  return `${formatted} ${currencySymbol(code)}`;
};
